// QueryClient compartilhado (TanStack Query) e convenções de cache.
// Chaves: arrays começando pela área — ["eu", "inicio"], ["equipe", "alunos", filtros] — para invalidar por prefixo.
import { QueryClient } from "@tanstack/react-query";
import { ErroApi } from "./cliente";
import { ehFalhaTransitoria } from "./erros";

/**
 * Consultas são GET (idempotentes): em falha transitória (rede caiu, 502/503/504 enquanto a API reinicia)
 * repetem por ~20 s com espera curta e crescente, e a tela mostra "Reconectando…" (Reconectando.tsx) em vez
 * de ficar vazia. 4xx não melhora repetindo; outros 5xx tentam mais uma vez.
 */
export const TENTATIVAS_FALHA_TRANSITORIA = 7;

export function deveRepetirConsulta(tentativas: number, erro: unknown): boolean {
  if (ehFalhaTransitoria(erro)) return tentativas < TENTATIVAS_FALHA_TRANSITORIA;
  if (erro instanceof ErroApi && erro.status >= 400 && erro.status < 500) return false;
  return tentativas < 1;
}

/** 0,5 s, 1 s, 2 s, 4 s e depois a cada 4 s (≈ 20 s no total com 7 tentativas). */
export const esperaEntreTentativas = (tentativa: number): number => Math.min(500 * 2 ** tentativa, 4_000);

export function criarQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: deveRepetirConsulta,
        retryDelay: esperaEntreTentativas,
      },
      // Escritas nunca repetem sozinhas (não são idempotentes); o erro vira aviso pelo useMutacao.
      mutations: { retry: false },
    },
  });
}
